import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    children: [{
      path: '', 
      loadChildren: () => import('./core/core-routing').then(m => m.routes)
    }]
  },
  {
    path: '**',
    redirectTo: ""
  }
];
